/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublisherResponsePage } from '../../models/publisher-response-page';

export interface ListPublishers$Params {
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'homepage' | '-homepage' | 'feed' | '-feed' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listPublishers(http: HttpClient, rootUrl: string, params?: ListPublishers$Params, context?: HttpContext): Observable<StrictHttpResponse<PublisherResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listPublishers.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {"style":"form"});
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublisherResponsePage>;
    })
  );
}

listPublishers.PATH = '/v0/publishers';
